import React from 'react';

/** @internal */
export var removeIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.8277 19.9902C21.0584 20.2208 21.0584 20.5947 20.8277 20.8253C20.5971 21.0559 20.2232 21.0559 19.9926 20.8253L12.5004 13.3331L5.00621 20.8273C4.77625 21.0572 4.40341 21.0572 4.17345 20.8273C3.94349 20.5973 3.94349 20.2245 4.17345 19.9945L11.6676 12.5003L4.17537 5.00808C3.94476 4.77747 3.94476 4.40357 4.17537 4.17296C4.40599 3.94235 4.77988 3.94235 5.01049 4.17296L12.5027 11.6652L19.9931 4.17489C20.223 3.94493 20.5959 3.94493 20.8258 4.17489C21.0558 4.40485 21.0558 4.77769 20.8258 5.00765L13.3355 12.498L20.8277 19.9902Z"
}));